import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function Main2018() {
  const handleDownload1 = () => {
    window.open("assets/2018/Lalhriatpuii Ralte.pdf", "_blank");
  };
  const handleDownload2 = () => {
    window.open("assets/2018/Lalfakawmi.pdf", "_blank");
  };
  const handleDownload3 = () => {
    window.open("assets/2018/K Vanrammawia.pdf", "_blank");
  };
  const handleDownload4 = () => {
    window.open("assets/2018/Lianchhungi.pdf", "_blank");
  };
  const handleDownload5 = () => {
    window.open("assets/2018/PL Ramliana.pdf", "_blank");
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className=" h-full justify-center items-center flex mx-20">
        <div className="flex flex-col-reverse lg:flex-row  justify-center items-center">
          {/* Book Cover */}
          <div className=" mr-20 sm:mt-0 md:mt-20 mt-20 flex flex-col justify-center items-center">
            <img className="h-96 w-60" src="mea.webp" />
            <div className=" text-center font-semibold">ISSN 2581-7523</div>
          </div>
          {/* Main Page */}
          <div className="">
            <div className="">
              <div className=" font-bold text-xl">Mizoram Economic Review</div>
              <div className="text-sm">Volume 1, No. 2 (2018)</div>
              <div className="text-sm">ISSN 2581-7523</div>
            </div>

            {/* Content */}
            <div className="mt-10 grid grid-row-1 gap-6">
              <button className="text-left" onClick={handleDownload1}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Vocational education and training: A current scenario in
                  Mizoram
                </div>
                <div className="text-sm text-green-600">Lalhriatpuii Ralte</div>
              </button>
              <button className="text-left" onClick={handleDownload2}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Emergence of inclusive healthcare system in Mizoram: An
                  evaluation
                </div>
                <div className="text-sm text-green-600">Lalfakawmi</div>
              </button>
              <button className="text-left" onClick={handleDownload3}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Constraints on agricultural finance in Mizoram: An analysis
                </div>
                <div className="text-sm text-green-600">K. Vanrammawia</div>
              </button>
              <button className="text-left" onClick={handleDownload4}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Impact of Mid-day meal on Primary and Middle Schools: A study
                  on Bawngkawn and Electric education cluster
                </div>
                <div className="text-sm text-green-600">Lianchhungi</div>
              </button>
              <button className="text-left" onClick={handleDownload5}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Causes and classifications of poverty: A review of evidences
                </div>
                <div className="text-sm text-green-600">PL Ramliana</div>
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
